// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CloudReflashSvg from '@rsuite/icon-font/lib/network/CloudReflash';
var CloudReflash = createSvgIcon({
  as: CloudReflashSvg,
  ariaLabel: 'cloud reflash',
  category: 'network',
  displayName: 'CloudReflash'
});
export default CloudReflash;